import MainLayoutContainer from '@layouts/main-layout/container';
import MainList from './main-list';

const MainLayout = () => {
	return (
		<MainLayoutContainer>
			<MainList />
		</MainLayoutContainer>
	);
};

export default MainLayout;
